import { api } from ":mods";
import { ENDPOINTS } from "../const";

export async function getSchedulesList(stage_id: string | number) {
  return api.getAuth(ENDPOINTS.get_schedule_list + stage_id).then((res) => res.data);
}
